<script>
  export let label,
    labelNote,
    name,
    placeholder,
    required = false,
    id = null,
    autocomplete = null,
    type = 'text',
    value = '',
    title = null;
</script>

<div class="input">
  {#if label}
    <label for={name}
      >{label}
      {#if required}<small>*</small>{/if}</label
    >
  {/if}
  {#if type === 'password'}
    <input type="password" {id} {name} {placeholder} {autocomplete} {required} {title} on:change on:blur bind:value />
  {:else if type === 'email'}
    <input type="email" {id} {name} {placeholder} {autocomplete} {required} {title} on:change on:blur bind:value />
  {:else if type === 'number'}
    <input type="number" {id} {name} {placeholder} {autocomplete} {required} {title} on:change on:blur bind:value />
  {:else if type === 'date'}
    <input type="date" {id} {name} {placeholder} {autocomplete} {required} {title} on:change on:blur bind:value />
  {:else}
    <input
      type="text"
      {id}
      {name}
      {placeholder}
      {autocomplete}
      {required}
      {title}
      on:change
      on:blur
      on:invalid
      on:input
      bind:value
    />
  {/if}
  {#if labelNote}
    <label class="note" for={name}>{labelNote}</label>
  {/if}
</div>

<style>
  input {
    padding: 1.5rem;
    font-family: 'Inter', sans-serif;
    font-weight: 400;
    border-radius: 0.5rem;
    border: 1px solid #777;
    max-width: 95%;
  }

  label {
    font-size: 1.8rem;
    font-family: 'Inter', sans-serif;
    font-weight: 600;
    margin-bottom: 1.5rem;
  }

  label.note {
    font-size: 1.1rem;
    font-family: 'Inter', sans-serif;
    font-weight: 600;
    margin-bottom: 1rem;
    color: #585858;
    text-transform: capitalize;
    margin-top: 0.2rem;
    text-align: left;
  }

  small {
    color: #fe5900;
  }

  .input {
    display: flex;
    flex-direction: column;
  }
</style>
